/* REACT */
import React, { useEffect, useState } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import queryString from 'query-string'

/* COMPONENTS */
import FullSearch from './FullSearch/FullSearch'
import QuickSearch from './QuickSearch/QuickSearch'

/* STORE */
import {
  fetchOrganizationDetails,
  setDefaultSearchResults,
  setSearchQuery,
  setGnerateAiQueryResponse,
  setIsFetchingAiQueryResponse,
} from '../../store/maya/actions'
import { setGeneralConfig } from '../../store/general/actions'
import { getSearchFilters, getSearchGrids } from '../../store/maya/selectors'

/* STYLES */

/* UTILS/CONSTANTS/IMAGES-ASSETS */
import { size, CLIENT_STYLINGS } from '../../utils/constants'

const Search = ({
  organizationKey,
  organizationSlug,
  widgetMode,
  chatMode,
  language,
  setGeneralConfig,
  stateOrganizationSlug,
  stateOrganizationKey,
  stateLanguage,
  stateWidgetMode,
  stateChatMode,
  introType,
}) => {
  const [isConfigSet, setIsConfigSet] = useState(false)
  const [detailsFetched, setDetailsFetched] = useState(false)

  const isLessThanLaptop = useMediaQuery({
    query: `(max-width: ${size.laptop})`,
  })

  useEffect(() => {
    if (!isConfigSet && organizationKey && organizationSlug && language) {
      setIsConfigSet(true) // JUST SET SOCKET ONE TIME

      const { query } = queryString.parseUrl(window.location.search)

      // SAVE CREDENTIALS IN STORE
      setGeneralConfig({
        organizationKey,
        organizationSlug,
        language: language || 'en',
        widgetMode: widgetMode,
        chatMode: chatMode, // b2c IS OUR DEFAULT EXISTING CHAT MODE
        introType: introType || query?.intro_type || 'default', // default intro type i.e. default messages
      })
    }
  }, [])

  useEffect(() => {
    // HOOK HANDLING FOR FETCHING ORGANIZATION DETAILS

    if (
      stateOrganizationSlug &&
      stateOrganizationKey &&
      stateLanguage &&
      stateWidgetMode &&
      stateChatMode &&
      !detailsFetched
    ) {
      setDetailsFetched(true)

      // FETCH ORGANIZATION DETAILS
      fetchOrganizationDetails()
    }
  }, [
    stateOrganizationSlug,
    stateOrganizationKey,
    stateLanguage,
    stateWidgetMode,
  ])

  return (
    <>
      {stateOrganizationSlug && stateWidgetMode ? (
        stateWidgetMode === 'search' ? (
          <FullSearch
            organizationKey={organizationKey}
            organizationSlug={organizationSlug}
            chatMode={chatMode}
            widgetMode={widgetMode}
            language={language}
          />
        ) : stateWidgetMode === 'quick-search' ? (
          <QuickSearch
            organizationKey={organizationKey}
            organizationSlug={organizationSlug}
            chatMode={chatMode}
            widgetMode={widgetMode}
            language={language}
          />
        ) : null
      ) : null}
    </>
  )
}

const mapStateToProps = state => ({
  stateOrganizationSlug: state.general.organizationSlug,
  stateOrganizationKey: state.general.organizationKey,
  stateLanguage: state.general.language,
  stateWidgetMode: state.general.widgetMode,
  stateChatMode: state.general.chatMode,
  quickSearches: state.maya.quickSearches,
  defaultSearchResults: state.maya.defaultSearchResults,
  searchQuery: state.maya.searchQuery,
  searchAiTextResponse: state.maya.searchAiTextResponse,
  isFetchingSearchResults: state.maya.isFetchingSearchResults,
  isFetchingAiQueryResponse: state.maya.isFetchingAiQueryResponse,
  searchGrids: getSearchGrids(state),
  generateAiQueryResponse: state.maya.generateAiQueryResponse,
  isInternalCaseInQueryOrOptions: state.maya.isInternalCaseInQueryOrOptions,
  searchFilters: getSearchFilters(state),
})

const mapDispatchToProps = dispatch => ({
  setGeneralConfig: config => dispatch(setGeneralConfig(config)),
  setDefaultSearchResults: value => dispatch(setDefaultSearchResults(value)),
  setSearchQuery: query => dispatch(setSearchQuery(query)),
  setGnerateAiQueryResponse: value =>
    dispatch(setGnerateAiQueryResponse(value)),
  setIsFetchingAiQueryResponse: value =>
    dispatch(setIsFetchingAiQueryResponse(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
